module.exports = __webpack_public_path__ + "img/1 (39).17f39b8e.png";